import React from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import App from './App';
import theme from './theme';
import { API_BASE_URL } from './config';
import 'fontsource-roboto';

function reportUnhandledError({ message, source, line, column, stack }) {
  fetch(`${API_BASE_URL}/api/internal/frontend-errors`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      message,
      url: window.location.href,
      source,
      line,
      column,
      stack,
    }),
    keepalive: true,
  }).catch(() => {
    // Reporting must never cause another unhandled browser error.
  });
}

window.addEventListener('error', (event) => {
  reportUnhandledError({
    message: event.message || 'Uncaught browser error',
    source: event.filename,
    line: event.lineno,
    column: event.colno,
    stack: event.error?.stack,
  });
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  reportUnhandledError({
    message: reason instanceof Error ? reason.message : String(reason),
    stack: reason instanceof Error ? reason.stack : undefined,
  });
});

ReactDOM.render(
  <ThemeProvider theme={theme}>
    {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
    <CssBaseline />
    <App />
  </ThemeProvider>,
  document.querySelector('#root'),
);
